import Select, { OnChangeValue } from 'react-select';
import { useAsyncResource } from 'use-async-resource';
import { Option } from '../models/table-models';
import { useTranslation } from 'react-i18next';
import { FilterMultiSelectProps } from './LogsMultiSelect';
import { useGetAllRoles } from '../utils/users-hooks';
import { stringsToOptions } from './FormMultiSelect';

export const UserRoleMultiSelect = ({ filter, setFilter }: FilterMultiSelectProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'multiselect' });

    const onChange = (value: OnChangeValue<Option, true>) => {
        let strings = value.map(({ value }) => value);
        setFilter({ ...filter, tags: strings });
    };
    const [options] = useAsyncResource(useGetAllRoles, []);
    const logs = stringsToOptions(options());
    return (
        <Select
            className='logs-select'
            placeholder={t('filterTags')}
            isMulti
            name='colors'
            isClearable
            options={logs}
            getOptionLabel={(option) => t(option.name)}
            getOptionValue={(option) => option.value}
            onChange={onChange}
            backspaceRemovesValue
        />
    );
};
